export default { sha: 'c68d5b111ee52f603936a9ce2eec5307ed497385', buildNumber: 'undefined' }
